import { render, staticRenderFns } from "./TwinWaterwayIntro.vue?vue&type=template&id=598afe32&"
import script from "./TwinWaterwayIntro.vue?vue&type=script&lang=js&"
export * from "./TwinWaterwayIntro.vue?vue&type=script&lang=js&"
import style0 from "./TwinWaterwayIntro.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports